export { default as AddressCard } from './AddressCard';
export { default as Apartment } from './Apartment';
export { default as Apple } from './Apple';
export { default as ArrowDown } from './ArrowDown';
export { default as ArrowLeft } from './ArrowLeft';
export { default as ArrowRight } from './ArrowRight';
export { default as ArrowUpRightFromSquare } from './ArrowUpRightFromSquare';
export { default as ArrowUp } from './ArrowUp';
export { default as ArrowsRotate } from './ArrowsRotate';
export { default as At } from './At';
export { default as Award } from './Award';
export { default as Bandage } from './Bandage';
export { default as Bars } from './Bars';
export { default as BellExclamation } from './BellExclamation';
export { default as BellOn } from './BellOn';
export { default as BellSlash } from './BellSlash';
export { default as Bell } from './Bell';
export { default as BoxArchive } from './BoxArchive';
export { default as BrainCircuit } from './BrainCircuit';
export { default as Brain } from './Brain';
export { default as BriefcaseMedical } from './BriefcaseMedical';
export { default as Briefcase } from './Briefcase';
export { default as Browser } from './Browser';
export { default as Bug } from './Bug';
export { default as CakeCandles } from './CakeCandles';
export { default as CalendarCheck } from './CalendarCheck';
export { default as Calendar } from './Calendar';
export { default as Camera } from './Camera';
export { default as Capsules } from './Capsules';
export { default as CaretDown } from './CaretDown';
export { default as CaretLeft } from './CaretLeft';
export { default as CaretRight } from './CaretRight';
export { default as CaretUp } from './CaretUp';
export { default as ChartPieSimple } from './ChartPieSimple';
export { default as Check } from './Check';
export { default as ChevronDown } from './ChevronDown';
export { default as ChevronLeft } from './ChevronLeft';
export { default as ChevronRight } from './ChevronRight';
export { default as ChevronUp } from './ChevronUp';
export { default as Circle0 } from './Circle0';
export { default as Circle1 } from './Circle1';
export { default as Circle2 } from './Circle2';
export { default as Circle3 } from './Circle3';
export { default as Circle4 } from './Circle4';
export { default as Circle5 } from './Circle5';
export { default as Circle6 } from './Circle6';
export { default as Circle7 } from './Circle7';
export { default as Circle8 } from './Circle8';
export { default as Circle9 } from './Circle9';
export { default as CircleCheck } from './CircleCheck';
export { default as CirclePlus } from './CirclePlus';
export { default as CircleQuestion } from './CircleQuestion';
export { default as CircleUser } from './CircleUser';
export { default as ClipboardCheck } from './ClipboardCheck';
export { default as ClipboardList } from './ClipboardList';
export { default as ClipboardPrescription } from './ClipboardPrescription';
export { default as ClipboardUser } from './ClipboardUser';
export { default as Clipboard } from './Clipboard';
export { default as Clock } from './Clock';
export { default as Comment } from './Comment';
export { default as Comments } from './Comments';
export { default as Copy } from './Copy';
export { default as CreditCard } from './CreditCard';
export { default as DiamondExclamation } from './DiamondExclamation';
export { default as Dna } from './Dna';
export { default as DoorClosed } from './DoorClosed';
export { default as DoorOpen } from './DoorOpen';
export { default as Download } from './Download';
export { default as EarDeaf } from './EarDeaf';
export { default as EarListen } from './EarListen';
export { default as Ear } from './Ear';
export { default as EarthAmericas } from './EarthAmericas';
export { default as EllipsisVertical } from './EllipsisVertical';
export { default as Ellipsis } from './Ellipsis';
export { default as Envelope } from './Envelope';
export { default as EyeLowVision } from './EyeLowVision';
export { default as EyeSlash } from './EyeSlash';
export { default as Eye } from './Eye';
export { default as Family } from './Family';
export { default as File } from './File';
export { default as Filter } from './Filter';
export { default as FlagPennant } from './FlagPennant';
export { default as Flag } from './Flag';
export { default as Flask } from './Flask';
export { default as FolderArrowDown } from './FolderArrowDown';
export { default as FolderArrowUp } from './FolderArrowUp';
export { default as FolderBookmark } from './FolderBookmark';
export { default as FolderClosed } from './FolderClosed';
export { default as FolderGear } from './FolderGear';
export { default as FolderOpen } from './FolderOpen';
export { default as Folder } from './Folder';
export { default as Gear } from './Gear';
export { default as Gift } from './Gift';
export { default as Glasses } from './Glasses';
export { default as Globe } from './Globe';
export { default as GripDotsVertical } from './GripDotsVertical';
export { default as GripDots } from './GripDots';
export { default as GripLinesVertical } from './GripLinesVertical';
export { default as GripLines } from './GripLines';
export { default as HandHoldingDroplet } from './HandHoldingDroplet';
export { default as HandHoldingHand } from './HandHoldingHand';
export { default as HandHoldingHeart } from './HandHoldingHeart';
export { default as HandHoldingMedical } from './HandHoldingMedical';
export { default as HandHoldingSeedling } from './HandHoldingSeedling';
export { default as HandsBubbles } from './HandsBubbles';
export { default as Handshake } from './Handshake';
export { default as Heart } from './Heart';
export { default as Hospital } from './Hospital';
export { default as House } from './House';
export { default as IdCard } from './IdCard';
export { default as Info } from './Info';
export { default as Key } from './Key';
export { default as KitMedical } from './KitMedical';
export { default as Laptop } from './Laptop';
export { default as Leaf } from './Leaf';
export { default as Lightbulb } from './Lightbulb';
export { default as LinkSimpleSlash } from './LinkSimpleSlash';
export { default as LinkSimple } from './LinkSimple';
export { default as ListCheck } from './ListCheck';
export { default as LockOpen } from './LockOpen';
export { default as Lock } from './Lock';
export { default as Lungs } from './Lungs';
export { default as MagnifyingGlass } from './MagnifyingGlass';
export { default as MailboxFlagUp } from './MailboxFlagUp';
export { default as Mailbox } from './Mailbox';
export { default as MapPin } from './MapPin';
export { default as Map } from './Map';
export { default as MaskFace } from './MaskFace';
export { default as Medal } from './Medal';
export { default as MicrophoneSlash } from './MicrophoneSlash';
export { default as Microphone } from './Microphone';
export { default as Microsoft } from './Microsoft';
export { default as Mobile } from './Mobile';
export { default as MoneyBill } from './MoneyBill';
export { default as MonitorWaveform } from './MonitorWaveform';
export { default as MoonOverSun } from './MoonOverSun';
export { default as NoteSticky } from './NoteSticky';
export { default as Note } from './Note';
export { default as Notebook } from './Notebook';
export { default as NotesMedical } from './NotesMedical';
export { default as Notes } from './Notes';
export { default as PaperPlane } from './PaperPlane';
export { default as Paperclip } from './Paperclip';
export { default as PartyHorn } from './PartyHorn';
export { default as Paste } from './Paste';
export { default as PenCircle } from './PenCircle';
export { default as PenField } from './PenField';
export { default as PenRuler } from './PenRuler';
export { default as PenToSquare } from './PenToSquare';
export { default as Pen } from './Pen';
export { default as PeopleSimple } from './PeopleSimple';
export { default as People } from './People';
export { default as Person } from './Person';
export { default as Phone } from './Phone';
export { default as Pills } from './Pills';
export { default as Plane } from './Plane';
export { default as Plus } from './Plus';
export { default as PrescriptionBottleMedical } from './PrescriptionBottleMedical';
export { default as PrescriptionBottlePill } from './PrescriptionBottlePill';
export { default as PrescriptionBottle } from './PrescriptionBottle';
export { default as Prescription } from './Prescription';
export { default as Print } from './Print';
export { default as PuzzlePiece } from './PuzzlePiece';
export { default as Puzzle } from './Puzzle';
export { default as Receipt } from './Receipt';
export { default as RectangleHistory } from './RectangleHistory';
export { default as RectangleList } from './RectangleList';
export { default as ReplyAll } from './ReplyAll';
export { default as Reply } from './Reply';
export { default as RestroomSimple } from './RestroomSimple';
export { default as Ribbon } from './Ribbon';
export { default as RocketLaunch } from './RocketLaunch';
export { default as ScaleBalanced } from './ScaleBalanced';
export { default as ScaleUnbalanced } from './ScaleUnbalanced';
export { default as ScalpelLineDashed } from './ScalpelLineDashed';
export { default as ScrewdriverWrench } from './ScrewdriverWrench';
export { default as Seedling } from './Seedling';
export { default as ShareAll } from './ShareAll';
export { default as ShareFromSquare } from './ShareFromSquare';
export { default as Share } from './Share';
export { default as Shield } from './Shield';
export { default as SignatureLock } from './SignatureLock';
export { default as SignatureSlash } from './SignatureSlash';
export { default as Signature } from './Signature';
export { default as SignsPost } from './SignsPost';
export { default as Sliders } from './Sliders';
export { default as Smoking } from './Smoking';
export { default as Snooze } from './Snooze';
export { default as SortDown } from './SortDown';
export { default as SortUp } from './SortUp';
export { default as Sort } from './Sort';
export { default as Sparkles } from './Sparkles';
export { default as StaffSnake } from './StaffSnake';
export { default as StarOfLife } from './StarOfLife';
export { default as Star } from './Star';
export { default as Stethoscope } from './Stethoscope';
export { default as Syringe } from './Syringe';
export { default as Table } from './Table';
export { default as Tablets } from './Tablets';
export { default as Tag } from './Tag';
export { default as Tags } from './Tags';
export { default as ThumbsDown } from './ThumbsDown';
export { default as ThumbsUp } from './ThumbsUp';
export { default as Thumbtack } from './Thumbtack';
export { default as Tiktok } from './Tiktok';
export { default as Transgender } from './Transgender';
export { default as TrashArrowUp } from './TrashArrowUp';
export { default as TrashCheck } from './TrashCheck';
export { default as TrashClock } from './TrashClock';
export { default as TrashList } from './TrashList';
export { default as TrashPlus } from './TrashPlus';
export { default as TrashSlash } from './TrashSlash';
export { default as TrashUndo } from './TrashUndo';
export { default as TrashXmark } from './TrashXmark';
export { default as Trash } from './Trash';
export { default as Tree } from './Tree';
export { default as TriangleExclamation } from './TriangleExclamation';
export { default as Trophy } from './Trophy';
export { default as TruckMedical } from './TruckMedical';
export { default as Twitter } from './Twitter';
export { default as UmbrellaBeach } from './UmbrellaBeach';
export { default as Unlock } from './Unlock';
export { default as Upload } from './Upload';
export { default as UserCheck } from './UserCheck';
export { default as UserDoctor } from './UserDoctor';
export { default as User } from './User';
export { default as Users } from './Users';
export { default as Video } from './Video';
export { default as VirusCovidSlash } from './VirusCovidSlash';
export { default as VirusCovid } from './VirusCovid';
export { default as WheelchairMove } from './WheelchairMove';
export { default as Window } from './Window';
export { default as WineGlass } from './WineGlass';
export { default as Wrench } from './Wrench';
export { default as Xmark } from './Xmark';
export { default as Youtube } from './Youtube';

export const iterableIconTypes = [
  'AddressCard',
  'Apartment',
  'Apple',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'ArrowUpRightFromSquare',
  'ArrowUp',
  'ArrowsRotate',
  'At',
  'Award',
  'Bandage',
  'Bars',
  'BellExclamation',
  'BellOn',
  'BellSlash',
  'Bell',
  'BoxArchive',
  'BrainCircuit',
  'Brain',
  'BriefcaseMedical',
  'Briefcase',
  'Browser',
  'Bug',
  'CakeCandles',
  'CalendarCheck',
  'Calendar',
  'Camera',
  'Capsules',
  'CaretDown',
  'CaretLeft',
  'CaretRight',
  'CaretUp',
  'ChartPieSimple',
  'Check',
  'ChevronDown',
  'ChevronLeft',
  'ChevronRight',
  'ChevronUp',
  'Circle0',
  'Circle1',
  'Circle2',
  'Circle3',
  'Circle4',
  'Circle5',
  'Circle6',
  'Circle7',
  'Circle8',
  'Circle9',
  'CircleCheck',
  'CirclePlus',
  'CircleQuestion',
  'CircleUser',
  'ClipboardCheck',
  'ClipboardList',
  'ClipboardPrescription',
  'ClipboardUser',
  'Clipboard',
  'Clock',
  'Comment',
  'Comments',
  'Copy',
  'CreditCard',
  'DiamondExclamation',
  'Dna',
  'DoorClosed',
  'DoorOpen',
  'Download',
  'EarDeaf',
  'EarListen',
  'Ear',
  'EarthAmericas',
  'EllipsisVertical',
  'Ellipsis',
  'Envelope',
  'EyeLowVision',
  'EyeSlash',
  'Eye',
  'Family',
  'File',
  'Filter',
  'FlagPennant',
  'Flag',
  'Flask',
  'FolderArrowDown',
  'FolderArrowUp',
  'FolderBookmark',
  'FolderClosed',
  'FolderGear',
  'FolderOpen',
  'Folder',
  'Gear',
  'Gift',
  'Glasses',
  'Globe',
  'GripDotsVertical',
  'GripDots',
  'GripLinesVertical',
  'GripLines',
  'HandHoldingDroplet',
  'HandHoldingHand',
  'HandHoldingHeart',
  'HandHoldingMedical',
  'HandHoldingSeedling',
  'HandsBubbles',
  'Handshake',
  'Heart',
  'Hospital',
  'House',
  'IdCard',
  'Info',
  'Key',
  'KitMedical',
  'Laptop',
  'Leaf',
  'Lightbulb',
  'LinkSimpleSlash',
  'LinkSimple',
  'ListCheck',
  'LockOpen',
  'Lock',
  'Lungs',
  'MagnifyingGlass',
  'MailboxFlagUp',
  'Mailbox',
  'MapPin',
  'Map',
  'MaskFace',
  'Medal',
  'MicrophoneSlash',
  'Microphone',
  'Microsoft',
  'Mobile',
  'MoneyBill',
  'MonitorWaveform',
  'MoonOverSun',
  'NoteSticky',
  'Note',
  'Notebook',
  'NotesMedical',
  'Notes',
  'PaperPlane',
  'Paperclip',
  'PartyHorn',
  'Paste',
  'PenCircle',
  'PenField',
  'PenRuler',
  'PenToSquare',
  'Pen',
  'PeopleSimple',
  'People',
  'Person',
  'Phone',
  'Pills',
  'Plane',
  'Plus',
  'PrescriptionBottleMedical',
  'PrescriptionBottlePill',
  'PrescriptionBottle',
  'Prescription',
  'Print',
  'PuzzlePiece',
  'Puzzle',
  'Receipt',
  'RectangleHistory',
  'RectangleList',
  'ReplyAll',
  'Reply',
  'RestroomSimple',
  'Ribbon',
  'RocketLaunch',
  'ScaleBalanced',
  'ScaleUnbalanced',
  'ScalpelLineDashed',
  'ScrewdriverWrench',
  'Seedling',
  'ShareAll',
  'ShareFromSquare',
  'Share',
  'Shield',
  'SignatureLock',
  'SignatureSlash',
  'Signature',
  'SignsPost',
  'Sliders',
  'Smoking',
  'Snooze',
  'SortDown',
  'SortUp',
  'Sort',
  'Sparkles',
  'StaffSnake',
  'StarOfLife',
  'Star',
  'Stethoscope',
  'Syringe',
  'Table',
  'Tablets',
  'Tag',
  'Tags',
  'ThumbsDown',
  'ThumbsUp',
  'Thumbtack',
  'Tiktok',
  'Transgender',
  'TrashArrowUp',
  'TrashCheck',
  'TrashClock',
  'TrashList',
  'TrashPlus',
  'TrashSlash',
  'TrashUndo',
  'TrashXmark',
  'Trash',
  'Tree',
  'TriangleExclamation',
  'Trophy',
  'TruckMedical',
  'Twitter',
  'UmbrellaBeach',
  'Unlock',
  'Upload',
  'UserCheck',
  'UserDoctor',
  'User',
  'Users',
  'Video',
  'VirusCovidSlash',
  'VirusCovid',
  'WheelchairMove',
  'Window',
  'WineGlass',
  'Wrench',
  'Xmark',
  'Youtube',
] as const;

export type IconTypes = typeof iterableIconTypes[number];
